<script setup>
import { ref, watch, computed, inject } from 'vue';

//properties set by parent
const props = defineProps({
	label: {type: String},
	min: { type: Number, default: 0 },
	max: { type: Number, default: 100 },
	step: { type: Number, default: 1 },
	modelValue: {
		type: Number,
		required: true
	},
});

//events raised by component
const emit = defineEmits(['update:modelValue']);
const { userInputState } = inject('userInputState')

let timeoutId = null;

//reactive field proxies
const currentValue = ref(props.modelValue)
const inputValue = ref(props.modelValue)

/* const fillLeft = computed(() => ((localMin.value - props.min) / (props.max - props.min)) * 100);
const fillWidth = computed(() => {
	return ((localMax.value - localMin.value) / (props.max - props.min)) * 100
}); */

const isDisabled = computed(() => {
	return props.min === props.max
})

const handleInput = () => {
	inputValue.value = currentValue.value
	userInputState.value.year = true;
	emit('update:modelValue', parseInt(currentValue.value));
};


/* watch(
	() => props.modelValue,
	(newValue) => {
		currentValue.value =  newValue
		emit('update:modelValue', currentValue.value);
	}
); */

const validateInput = () => {
	if(inputValue.value < props.min) inputValue.value = props.min;
	if(inputValue.value > props.max) inputValue.value = props.max;
	currentValue.value = inputValue.value
	handleInput()
}

/*onMounted(() => {
	currentValue.value = props.modelValue;
	inputValue.value = props.modelValue;
	handleInput()
})*/

/*watch(() => props.modelValue,
	(newValue) => {
		//delay setting ref field, needed to reset field after new indicator has been loaded
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => {
			props.modelValue = parseInt(newValue);
			handleInput();
		}, 300); // Wait 300ms after last change		
	}
); */
watch(() => props.modelValue,
	(newValue) => {
		validateInput();
	}
);

</script>

<template>
	<div class="range-container">
		<label><span class="subtle-label">Selected {{props.label}}</span>
		<input id="filter-slider-input-text" type="number" class="range-input" maxlength="4" :disabled="isDisabled" v-model="inputValue" @change="validateInput()">
		<input id="filter-slider-value" type="range" :min="min" :max="max" :step="step" :disabled="isDisabled" v-model.lazy="currentValue" @change="handleInput"
			class="range-slider" />
		<div class="slider-legend subtle-label"><span>{{props.min}}</span><span>{{props.max}}</span></div>
		</label>
	</div>
</template>

<style scoped>
.range-container {
	display: flex;
	flex-direction: column;
	width: 100%;
	padding:0.125rem;
}

.slider-legend {
	display:flex;
	justify-content: space-between;
	margin-top: .5rem;;

}

.subtle-label {
	color: var(--text-Secondary, #757575);

	/* Medium/Base */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 1rem);
	font-style: normal;
	font-weight: 500;
	line-height: var(--font-line-height-Base, 1.5rem); /* 150% */
}

.range-slider {
	margin-top: 3rem;

  -webkit-appearance: none; /* Remove default styling for WebKit browsers */
  width: 100%; /* Full width */
  height: 0.375rem; /* Height of the track */
  background: var(--border-color-input-Active, #064291); /* Track color */
  border-radius: 5px; /* Rounded track */
  outline: none; /* Remove focus outline */
}

.range-slider::-webkit-slider-thumb {
	pointer-events: auto;
	-webkit-appearance: none; /* Remove default styling */
	appearance: none;
	height: 1.5rem;
	width: 1.5rem;
	background: var(--brand-color-DarkWhite);
	border-radius: 50%;
	border: 1px solid var(--brand-color-Grey);
	cursor: pointer;
}

.range-slider::-moz-range-thumb {
	pointer-events: auto;
	-webkit-appearance: none; /* Remove default styling */
	appearance: none;
	height: 1.5rem;
	width: 1.5rem;
	background: var(--brand-color-DarkWhite);
	border-radius: 50%;
	border: 1px solid var(--brand-color-Grey);
	cursor: pointer;	
}

.range-slider:disabled {
	cursor: default;	
	color: var(--text-Secondary);
	background-color: var(--text-Secondary);
}

.range-slider:disabled + .slider-legend {
	color: var(--text-Secondary)
}

.range-input {
	width: 100%;
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 1rem);	
	height: 2.5rem;
}

.range-input:disabled {
	cursor: default;	
	color: var(--text-Secondary)
}

</style>
